module.exports = __webpack_public_path__ + "static/media/Project3_Fig6.cd316197.png";